import React, { useState, useEffect } from "react";
import * as R from "ramda";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import SendIcon from "@material-ui/icons/Send";
import { Field } from "react-final-form";
import {
  cardapioApi,
  refeicaoReceitaApi,
  receitaApi,
  tipoRefeicaoApi,
  clienteApi,
  refeicaoApi,
} from "../../services/Api";
import { MaskedField } from "../../components/fields/MaskedField";

import { TextField } from "final-form-material-ui";
import {
  List,
  Filter,
  MountEntity,
  autocompleteHelpers,
  loopback,
  CrudForm,
  WhenFieldChanges,
  crudFormEnums,
  useParentChildrenNavigation,
  CrudTabs,
  CrudRoute,
  Autocomplete,
  ListApi,
  FormApi,
  RichText,
  SimpleDialog,
  SimpleFormDialog,
} from "elentari";
import { Link } from "react-router-dom";
import { useCustomClientHaveFcm } from "../Fcm/hooks";

const { toOption } = autocompleteHelpers;
const { loopbackFilters } = loopback;

const CardapiosFilter = () => (
  <Filter
    formatFilters={{ clienteId: (value) => value.id }}
    labels={{ find: "Buscar", clear: "Limpar" }}
  >
    <Grid spacing={24} container>
      <Grid item xs>
        <Field
          label="Cliente"
          loadOptions={loadClientes}
          component={Autocomplete}
          name="clienteId"
        />
      </Grid>
    </Grid>
  </Filter>
);

export function CardapiosList(props) {
  const isFromCliente = !!props.match.params.id;
  const listOptions = {
    defaultOrder: "dataCadastro desc",
    fields: {
      cliente: isFromCliente
        ? null
        : {
            noOrder: true,
            label: "Cliente",
          },
      dataCadastro: {
        label: "Data Cadastro",
        format: (date) => (date ? moment(date).format("DD/MM/YYYY HH:mm") : ""),
      },
    },
  };

  const getPageDecorator = async ({ getPage }) => {
    const items = await getPage();
    if (!items) return;
    const promises = items.map(async (item) => {
      const response = await clienteApi.getOne(item.clienteId);
      if (response.ok) {
        item.cliente = response.data.nome;
        item.clienteId = undefined;
        return item;
      }
      return item;
    });
    return Promise.all(promises);
  };

  return (
    <ListApi
      getPageDecorator={getPageDecorator}
      api={cardapioApi}
      where={isFromCliente ? { clienteId: +props.match.params.id } : null}
    >
      {({ getPage, getCount, handleDelete }) => (
        <div>
          {isFromCliente ? null : <CardapiosFilter />}
          <List
            {...props}
            deleteItem={handleDelete}
            onClickEdit={(item) => props.history.push(`/cardapios/${item.id}`)}
            labelNew="Novo"
            getPage={getPage}
            getCount={getCount}
            listOptions={listOptions}
          />
        </div>
      )}
    </ListApi>
  );
}
const loadClientes = async (inputValue) => {
  const response = await clienteApi.getList({
    where: {
      nome: loopbackFilters.regexp(inputValue),
    },
    order: "nome asc",
    limit: 40,
  });
  if (response.ok) {
    return response.data.map(toOption("nome"));
  }
  return [];
};

export function CardapioForm(props) {
  const validate = (values) => ({
    cliente: values.cliente ? undefined : "Obrigatório",
  });
  const [copiaCardapioMessage, setCopiaCardapioMessage] = useState();
  const [statusNotificacao, setStatusNotificacao] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorOnSendMessage, setErrorOnSendMessage] = useState(false);

  const disabledTextFcm = useCustomClientHaveFcm(
    cardapioApi.getOne(props.match.params.id)
  );

  const fetchCardapio = async (event) => {
    if (props.match.params.id === "new") {
      setStatusNotificacao(false);
      return;
    }

    const response = await cardapioApi.getOne(props.match.params.id);

    if (response.ok) setStatusNotificacao(response.data.notificado);
  };

  useEffect(() => {
    fetchCardapio();
  }, []);

  const getItem = async () => {
    const searchParams = new URLSearchParams(props.location.search);

    if (props.match.params.id === "new" && searchParams.get("clienteId")) {
      const response = await clienteApi.getOne(searchParams.get("clienteId"));

      if (response.ok) {
        return {
          cliente: toOption("nome")(response.data),
        };
      }

      return;
    }

    return MountEntity(props, cardapioApi.getOne)
      .populate(({ data, id }) => ({
        cliente: clienteApi.getOne(data.clienteId),
      }))
      .clean(["clienteId"])
      .map((data) => ({
        ...data,
        cliente: toOption("nome")(data.cliente),
      }))
      .getItem();
  };

  const submitDecorator = async ({ data, id, handleSubmit }) => {
    return handleSubmit({
      id,
      data: {
        ...data,
        clienteId: data.cliente.id,
        cliente: undefined,
      },
    });
  };

  const enviarNotificacao = async (title, body) => {
    const id = props.match.params.id;
    const response = await cardapioApi.notify(id, { title, body });

    if (!response.ok) setErrorOnSendMessage(true);
  };

  const customActions = [
    {
      label: statusNotificacao ? "Notificar novamente" : "Notificar",
      icon: <SendIcon style={{ marginLeft: 10 }} />,
      onClick: () => setDialogOpen(true),
      pristine: crudFormEnums.PRISTINE_BEHAVIOR.DISABLED_WHEN_DIRTY,
    },
    {
      label: "Imprimir",
      props: {
        to: `/cardapios/${props.match.params.id}/print`,
        target: "_blank",
      },
      component: Link,
    },
    {
      label: "Duplicar",
      onClick: async () => {
        const response = await cardapioApi.duplicate(props.match.params.id);
        if (response.ok) {
          setCopiaCardapioMessage(
            "Cópia do cardápio realizada com sucesso! Este é o novo cardápio"
          );
          return props.history.replace(`/cardapios/${response.data.id}`);
        }
        setCopiaCardapioMessage("Erro ao fazer cópia do cardápio");
      },
    },
  ];

  const {
    match: { params },
  } = props;
  const showCustomActions = () => params.id !== "new";

  return (
    <div>
      <FormApi submitDecorator={submitDecorator} api={cardapioApi} {...props}>
        {({ handleSubmit }) => (
          <CrudForm
            withPaper
            validate={validate}
            history={props.history}
            getItem={getItem}
            customActions={showCustomActions() ? customActions : []}
            onSubmit={handleSubmit}
          >
            <Grid container spacing={16}>
              <Grid item sm>
                <Field
                  label="Cliente"
                  loadOptions={loadClientes}
                  component={Autocomplete}
                  name="cliente"
                />
              </Grid>
              <Grid item sm={12}>
                <Field
                  component={RichText}
                  name="informacoesComplementares"
                  label="Informações Complementares"
                />
              </Grid>
            </Grid>
          </CrudForm>
        )}
      </FormApi>
      <SimpleDialog
        title="Cópia do Cardápio"
        message={copiaCardapioMessage}
        open={!!copiaCardapioMessage}
        handleClose={() => setCopiaCardapioMessage("")}
      />
      <SimpleFormDialog
        title="Notificar"
        open={dialogOpen}
        buttonLabel="Cancelar"
        primaryAction={(title, body) =>
          enviarNotificacao(title, body).then(fetchCardapio)
        }
        primaryActionButtonLabel="Enviar"
        firstFormLabel="Título"
        firstDefaultValue="Nutrição"
        secondFormLabel="Mensagem"
        secondDefaultValue="Seu novo cardápio está disponível!"
        disabledText={disabledTextFcm}
        handleClose={() => setDialogOpen(false)}
      />
      <SimpleDialog
        title="Atenção"
        message="Ocorreu um erro no envio da mensagem, por favor tente novamente mais tarde."
        open={errorOnSendMessage}
        primaryActionButtonLabel="Ok"
        handleClose={() => setErrorOnSendMessage(null)}
      />
    </div>
  );
}

function RefeicaoList(props) {
  const listOptions = {
    defaultOrder: "horario",
    fields: {
      titulo: {
        label: "Título",
      },
      horario: {
        label: "Horário",
      },
      tituloReceitas: {
        label: "Receitas",
        format: (values) => values.join(", "),
      },
    },
  };

  const getPageDecorator = async () => {
    const response = await refeicaoApi.getList(props.match.params.id);
    if (response.ok) {
      return response.data;
    }
  };

  return (
    <ListApi api={refeicaoApi} getPageDecorator={getPageDecorator}>
      {({ getPage, getCount, handleDelete }) => (
        <List
          {...props}
          withPaper
          deleteItem={handleDelete}
          labelNew="Novo"
          onClickEdit={(item) =>
            props.history.push(`${props.location.pathname}/${item.id}`)
          }
          onClickNew={props.onClickNew}
          getPage={getPage}
          listOptions={listOptions}
        />
      )}
    </ListApi>
  );
}

export function RefeicaoForm(props) {
  const validate = (values) => ({
    refeicao: values.refeicao ? undefined : "Obrigatório",
    horario: values.horario ? undefined : "Obrigatório",
  });
  const [tipoRefeicoes, setTipoRefeicoes] = useState({
    list: [],
    options: [],
  });

  const fetchTipoRefeicoes = async () => {
    const response = await tipoRefeicaoApi.getList();
    if (response.ok) {
      const list = response.data;
      const options = list.map((t) => ({
        id: t.id,
        horario: t.horario,
        label: t.nome,
      }));
      setTipoRefeicoes({
        list,
        options,
      });
    }
  };

  useEffect(() => {
    fetchTipoRefeicoes();
  }, [props.location.pathname]);

  const loadReceitasOptions = async (value) => {
    const response = await receitaApi.getList({
      where: value
        ? {
            or: [
              { tituloInterno: loopbackFilters.ilikeWithoutSplit(value) },
              { titulo: loopbackFilters.ilikeWithoutSplit(value) },
              { id: Number.isInteger(+value) ? value : undefined },
            ],
          }
        : {},
      order: "tituloInterno asc",
      limit: 250,
    });
    if (response.ok) {
      return response.data.map((r) => ({
        id: r.id,
        label: `${r.id} - ${r.tituloInterno} - ${r.titulo}`,
        value: r.id,
      }));
    }
  };

  const getItem = () => {
    return MountEntity(props, refeicaoApi.getOne)
      .populate(({ id, data }) => ({
        refeicao: tipoRefeicaoApi.getOne(data.refeicaoTipoId),
        refeicaoReceitas: refeicaoReceitaApi.getList({
          where: { refeicaoId: id },
          order: "indice desc, id desc",
        }),
      }))
      .populate(({ data }) => {
        return {
          receitas: data.refeicaoReceitas.map(async (refeicaoReceita) => {
            const response = await receitaApi.getOne(refeicaoReceita.receitaId);
            return {
              ok: true,
              data: {
                indice: refeicaoReceita.indice,
                ...response.data,
              },
            };
          }),
        };
      })
      .map((data) => ({
        ...data,
        refeicao: toOption("nome")(data.refeicao),
        receitas: data.receitas
          .sort((r1, r2) => r1.indice - r2.indice)
          .map((r) => ({
            id: r.id,
            label: `${r.id} - ${r.tituloInterno} - ${r.titulo}`,
            value: r.id,
          })),
      }))
      .clean(["refeicaoTipoId", "refeicaoReceitas"])
      .getItem();
  };

  const toRefeicaoReceita = (id) => (receita, indice) => ({
    receitaId: receita.id,
    refeicaoId: Number(id),
    indice,
  });

  const saveRefeicaoReceitas = async ({ receitas, id, isUpdate }) => {
    if (!receitas.length) {
      return { ok: true };
    }
    if (isUpdate) {
      const refeicaoReceitaResponse = await refeicaoReceitaApi.getList({
        where: { refeicaoId: id },
      });
      if (!refeicaoReceitaResponse.ok) {
        return { ok: false };
      }
      await Promise.all(
        refeicaoReceitaResponse.data.map((r) =>
          refeicaoReceitaApi.deleteF(r.id)
        )
      );
    }
    const refeicaoReceitas = receitas.map(toRefeicaoReceita(id));
    const responses = await Promise.all(
      refeicaoReceitas.map(refeicaoReceitaApi.create)
    );
    return {
      ok: R.all(R.prop("ok"), responses),
    };
  };

  const submitDecorator = async ({ id: currentId, data, handleSubmit }) => {
    const formated = {
      ...data,
      titulo: data.titulo || undefined,
      ordem: data.ordem || undefined,
      refeicaoTipoId: data.refeicao.id,
      cardapioId: Number(props.match.params.id),
      refeicao: undefined,
      receitas: undefined,
    };
    const result = await handleSubmit({
      id: currentId,
      data: formated,
    });
    if (result.ok) {
      return saveRefeicaoReceitas({
        receitas: data.receitas,
        id: Number(currentId) || result.data.id,
        isUpdate: !!Number(currentId),
      });
    }
    return result;
  };

  return (
    <FormApi {...props} api={refeicaoApi} submitDecorator={submitDecorator}>
      {({ handleSubmit }) => (
        <CrudForm
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <WhenFieldChanges
            field="refeicao"
            set="horario"
            to={(refeicao) => refeicao && refeicao.horario}
          />
          <Grid container spacing={16}>
            <Grid item sm={5}>
              <Field
                label="Título"
                fullWidth
                component={TextField}
                name="titulo"
              />
            </Grid>
            <Grid item sm={5}>
              <Field
                label="Tipo de Refeição"
                options={tipoRefeicoes.options}
                component={Autocomplete}
                name="refeicao"
              />
            </Grid>
            <Grid item sm>
              <Field
                mask={[/\d/, /\d/, ":", /\d/, /\d/]}
                label="Horário"
                component={MaskedField}
                name="horario"
              />
            </Grid>
            <Grid item sm={12}>
              <Field
                label="Receitas"
                loadOptions={loadReceitasOptions}
                isMulti
                component={Autocomplete}
                name="receitas"
              />
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}

export function CardapioTabs(props) {
  const { current, navigate } = useParentChildrenNavigation(props, {
    mainPath: "cardapios",
    availableTabs: ["refeicoes"],
  });
  return (
    <CrudTabs
      {...props}
      mainPath="cardapios"
      current={current}
      tabs={[
        { value: "", label: "Cardapio" },
        { value: "refeicoes", label: "Refeições" },
      ]}
      navigate={navigate}
    >
      <div>
        <CrudRoute render={() => <CardapioForm {...props} />} />
        <CrudRoute
          name="refeicoes"
          render={(props) => (
            <RefeicaoList onClickNew={navigate("newChild")} {...props} />
          )}
        />
        <CrudRoute
          name="refeicoes"
          isForm
          render={(props) => <RefeicaoForm {...props} />}
        />
      </div>
    </CrudTabs>
  );
}
